/* tslint:disable */
/* eslint-disable */
/**
 * Real Estate CRM API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const PaymentMethod = {
    Cash: 0,
    Bank: 1,
    Crypto: 2,
    Other: 3
} as const;

export type PaymentMethod = typeof PaymentMethod[keyof typeof PaymentMethod];



